import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../types';
import { AP_BUTTONS_MOBILE_WIDTH as MOBILE_WIDTH } from '../../../constants';
import { useWidth } from '../../common';
import { useSource } from '../../sources';
import { Button } from './Button';

interface ButtonsProps extends PropsWithClassName {
  containerWidth: number;
}

export function Buttons({ className, containerWidth }: ButtonsProps) {
  const [isFullWidth, setIsFullWidth] = useState(false);
  const { currentItem } = useSource();
  const { layout } = useSettings();
  const { width } = useWidth();

  const buttons = currentItem?.buttons;
  const isHorizontal = width <= MOBILE_WIDTH && layout === 'floating';

  useEffect(() => {
    const isMobileView = containerWidth <= MOBILE_WIDTH;
    if (isMobileView !== isFullWidth) {
      setIsFullWidth(isMobileView);
    }
  }, [containerWidth, isFullWidth]);

  if (!buttons?.length) {
    return null;
  }

  return (
    <StyledButtonContainer
      className={className}
      _isFullWidth={isFullWidth}
      _isHorizontal={isHorizontal}
    >
      {buttons?.map((item) => {
        const link =
          (item.type === 'download' ? currentItem?.link : item?.link) ?? '';

        return (
          <Button
            key={item.id}
            {...item}
            link={link}
            isFullWidth={isFullWidth}
            isHorizontal={isHorizontal}
            sourceType={currentItem?.sourceType}
          />
        );
      })}
    </StyledButtonContainer>
  );
}

const StyledButtonContainer = styled.div<{
  _isHorizontal?: boolean;
  _isFullWidth?: boolean;
}>`
  position: relative;
  display: flex;
  gap: 12px;

  ${({ _isHorizontal, _isFullWidth }) => `
      margin-top: ${!_isHorizontal && _isFullWidth ? '12px' : 0};
      width: ${!_isHorizontal && _isFullWidth ? '100%' : 'auto'};
    `}

  ${({ _isHorizontal }) =>
    _isHorizontal
      ? `
      flex-direction: row;
      overflow-y: auto;
      scrollbar-width: none;
    `
      : `
      flex-wrap: wrap;
      row-gap: 6px;
    `}
`;
